<template>
  <div class="page-wrapper">
    <transition name="fade" mode="out-in">
      <div v-if="loading"
        class="loading"
        :key="'loading'">
        <img src="../assets/loading.gif" alt="image de chargement">
      </div>
      <div v-else-if="error" :key="'api-error'">
        <message>
          {{ error }}
        </message>
      </div>
      <div v-else :key="'aides'">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import Message from '../components/Message'

export default {
  name: 'PageWrapper',
  components: {
    Message
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    error: {
      required: true
    }
  }
}
</script>

<style lang="scss">
.page-wrapper {
  .loading {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 70px;
    }
  }
}
</style>
